import { ImageContainer } from "@/components/styles";
import useUserStore from "@/state/user/useUserStore";
import { Upload } from "lucide-react";
import React, { useRef } from "react";

const UploadMemeTemplate = () => {
  const [setUploadedImage, setSelectedImage, setRatio, setImageFormat] =
    useUserStore((state) => [
      state.setUploadedImage,
      state.setSelectedImage,
      state.setRatio,
      state.setImageFormat,
    ]);

  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleUploadClick = () => {
    if (fileInputRef.current !== null) {
      fileInputRef.current.click();
    }
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files !== null) {
      const file = event.target.files[0];
      setUploadedImage(URL.createObjectURL(file));
      setSelectedImage(URL.createObjectURL(file));

      const image = new Image();

      image.onload = () => {
        const aspectRatio = image.naturalWidth / image.naturalHeight;
        setRatio(aspectRatio.toString());
        if (aspectRatio > 2) {
          setImageFormat("banner");
        } else {
          setImageFormat("post");
        }
      };

      image.src = URL.createObjectURL(file);
    }
  };

  return (
    <ImageContainer
      whileHover={{
        scale: 1.02,
        transition: {
          duration: 0.15,
          ease: "linear",
        },
      }}
      whileTap={{ scale: 0.99 }}
      onClick={handleUploadClick}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        gap: "8px",
        background: "#ccc",
      }}
    >
      <Upload style={{ width: "24px", height: "24px" }} />
      <p
        style={{
          margin: 0,
          fontSize: "16px",
          fontFamily: "var(--font-cabin-condensed)",
          whiteSpace: "nowrap",
        }}
      >
        Upload
      </p>
      <input
        type="file"
        accept="image/*"
        ref={fileInputRef}
        style={{ display: "none" }}
        onChange={handleFileChange}
      />
    </ImageContainer>
  );
};

export default UploadMemeTemplate;